import { render } from "./ins.vue?vue&type=template&id=148e3f98&scoped=true"
import script from "./ins.vue?vue&type=script&lang=js"
export * from "./ins.vue?vue&type=script&lang=js"

import "./ins.vue?vue&type=style&index=0&id=148e3f98&lang=scss&scoped=true"
import "./ins.vue?vue&type=style&index=1&id=148e3f98&lang=css"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148e3f98"]])

export default __exports__